import ActiveMembershipList from './ActiveMembershipList';

export default ActiveMembershipList;
